<template>
    <div class="context common_table_view" ref="common_table_view">
        <div class="header" ref="header">
            <div class="search">
                <div class="search_item" style="justify-content: space-between;">
                    <div class="input_box">
                        <el-input v-model="searchForm.input"
                                  placeholder="请输入姓名或完整手机号"
                                  class="width_400"
                                  @change="getTableData()"
                                  size="small"
                                  clearable></el-input>
                        <span style="padding-left: 10px">
                            <el-button type="primary"
                                size="small"
                                @click="getTableData()">搜索</el-button>
                        </span>
                    </div>
                    <el-button
                        type="primary"
                        size="small"
                        style="margin-right:50px;"
                        :loading="loadingExport"
                        @click="dialogVisible = true;"
                        v-if="powerPatient || powerOperation || powerFoundation || powerPublic || powerResult"
                        >
                        导出
                    </el-button>
                </div>
                <div class="search_item">
                    <div class="title has_title">状态：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in status_list"
                             :key="index"
                             :class="searchForm.status === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'status')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title has_title">跟进情况：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in visit_task_medication_status"
                             :key="index"
                             :class="searchForm.medication_status === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'medication_status')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title has_title">药物：</div>
                    <div class="input_box">
                        <div
                             :class="searchForm.drug_code === ''?'actived_btn':''"
                             @click="changeCell('', 'drug_code')"
                             class="btn">
                            不限
                        </div>
                        <div v-for="(item, index) in drug_code_list"
                             :key="index"
                             :class="searchForm.drug_code === item.drug_code?'actived_btn':''"
                             @click="changeCell(item.drug_code, 'drug_code')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title has_title">来源：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in classification_list"
                             :key="index"
                             :class="searchForm.classification === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'classification')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title has_title">
                        <el-dropdown @command="changeDateType">
                            <span class="el-dropdown-link title has_title">
                              {{searchForm.date_type | showDateName}}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                                <span>：</span>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item, index) in date_type_list"
                                                  :command="item.value"
                                                  :key="index">
                                    {{item.name}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="input_box">
                        <el-date-picker
                                v-model="searchForm.date"
                                value-format="yyyy-MM-dd"
                                @change="getTableData()"
                                unlink-panels
                                size="small"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title has_title">周期：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in Cycle_list"
                             :key="index"
                             :class="searchForm.Cycle_status.includes(item.value)?'actived_btn':''"
                             @click="changeCell(item.value, 'Cycle_status')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
                <!--
                <div class="search_item">
                    <div class="title has_title">癌种是否一致：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in ill_if_list"
                             :key="index"
                             :class="searchForm.tumor_is_consistent === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'tumor_is_consistent')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>-->
                <div class="search_item">
                    <!-- <div class="title has_title">区域：</div>
                    <el-select v-model="searchForm.province" filterable clearable @change="provinceChange" placeholder="请选择省份" size="small">
                        <el-option
                        v-for="item in province_list"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select> -->
                    <!-- <div class="title has_title">组织架构：</div>
                    <el-cascader
                        v-model="searchForm.department_id"
                        :options="areaData"
                        :props="treeOptions"
                        filterable
                        :show-all-levels="false"
                        clearable
                        size="small"
                        @change="provinceChange"
                        >
                    </el-cascader> -->
                    <div class="title has_title">
                        <el-dropdown @command="filtrate_dropdownCommand">
                            <span class="el-dropdown-link">
                                {{filtrate_dropdown}}<i class="el-icon-arrow-down el-icon--right"></i>：
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="区域">区域</el-dropdown-item>
                                <el-dropdown-item command="组织架构">组织架构</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <!-- <el-select
                        v-if="filtrate_dropdown == '区域'"
                        v-model="searchForm.province"
                        filterable clearable
                        @change="provinceChange"
                        placeholder="请选择省份"
                        size="small">
                        <el-option
                        v-for="item in province_list"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select> -->
                    <el-cascader
                        v-show="filtrate_dropdown == '区域'"
                        v-model="searchForm.province"
                        placeholder="请选择省市"
                        :options="city_list"
                        :props="cascader_props"
                        @change="provinceChange"
                        clearable
                        size="small"
                    >
                    </el-cascader>
                    <el-cascader
                        v-show="filtrate_dropdown == '组织架构'"
                        v-model="searchForm.department_id"
                        :options="areaData"
                        :props="treeOptions"
                        filterable
                        :show-all-levels="false"
                        clearable
                        size="small"
                        @change="provinceChange"
                        >
                    </el-cascader>
                    <div class="title has_title">医院：</div>
                    <el-select
                        v-model="searchForm.hospital_id"
                        @change="changeCell(searchForm.hospital_id, 'hospital_id')"
                        @blur="getHospital('')"
                        filterable
                        clearable
                        remote
                        :remote-method="remoteMethod"
                        placeholder="请选择医院"
                        size="small"
                        >
                        <el-option
                            v-for="item in hospital_list"
                            :key="item.hospital_id"
                            :label="item.name"
                            :value="item.hospital_id">
                        </el-option>
                    </el-select>
                </div>

                <div class="search_item">
                    <div class="title has_title">是否有凭证：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in invoice_info_list"
                             :key="index"
                             :class="searchForm.invoice_info === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'invoice_info')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="table" v-if="showTable">
            <el-table :data="tableData"
                      stripe
                      @row-dblclick="goToAudit"
                      width="100%"
                      :height="tableHeight">
                <el-table-column type="index" fixed="left" width="65" label="序号"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
            </el-table>
        </div>

        <div class="bottom_page" ref="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
        <el-dialog
            title="导出"
            :visible.sync="dialogVisible"
            :modal="false"
            width="30%"
            >
            <div>
                <el-checkbox-group v-model="reportCheckList">
                    <el-checkbox label="1" v-if="powerPatient">患者随访表</el-checkbox>
                    <br/>
                    <el-checkbox label="2" v-if="powerOperation">专员随访工单(运营)</el-checkbox>
                    <br/>
                    <el-checkbox label="3" v-if="powerFoundation">专员随访工单(基金会)</el-checkbox>
                    <br/>
                    <el-checkbox label="4" v-if="powerPublic">附表-公益专员架构表</el-checkbox>
                    <br/>
                    <el-checkbox label="5" v-if="powerResult">验真结果</el-checkbox>
                    <br/>
                    <el-checkbox label="6" v-if="powerResultFoundation">验真结果（基金会）</el-checkbox>
                    <br/>
                    <el-checkbox label="7" v-if="powerPointFollowUp">试点随访（基金会）</el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="reportChange">导 出</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import config from '@/global/config'
    import {clone, lcGetWithAge} from "../../global/utils";

    export default {
        name: "tableView",
        props: ['showTable'],
        components: {},
        data() {
            const showFinish = (row, column, cellValue, index) => {
                return cellValue == '1' ? '未完成' : cellValue == '2' ? '已完成' : cellValue == '3' ? '随访中' : ''
            };
            const showPhone = (row, column, cellValue, index) => {
                let text = row.patient_data.user_id == cellValue ? '' : cellValue;
                if(text){
                    text = text.replace(text.substring(3,7), "****")
                }
                return text;
            };
            const showPatientName = (row, column, cellValue, index) => {
                if(cellValue && cellValue.length <= 2){
                    cellValue = cellValue.split('')
                    cellValue.splice(1,0,'*')
                    cellValue = cellValue.join('')
                }
                if(cellValue){
                    cellValue = cellValue.replace(cellValue.substring(1,2), "*")
                }
                return cellValue;
            };
            const showVisitResult = (row, column, cellValue, index) => {
                let text = '';
                if(cellValue){
                    let result = JSON.parse(cellValue);
                    let medication_status = result.medication_status;
                    text = medication_status == '1' ? '未购药' : medication_status == '2' ? '已购药' : medication_status == '3' ? '已脱落' : ''
                }
                return text;
            };

            return {
                loadingExport: false,
                reportCheckList: [],
                filtrate_dropdown: "区域",
                dialogVisible: false,
                tableHeight: 0,
                currentPage: 1,
                pageSize: 50,
                total: 0,
                areaData: [],

                searchForm: {
                    input: '',
                    status: '',
                    medication_status: '', //跟进情况
                    drug_code: '',//药物
                    classification: '', //类别
                    T_status: '',
                    Cycle_status: [''], // 周期，默认不限，C1-C16多选
                    province: [], //省
                    department_id: '',//部门
                    hospital_id: '', //医院

                    date_type: '1',
                    date: [],

                    invoice_info: "",

                    // tumor_is_consistent: ''
                },
                cascader_props: {
                    expandTrigger: 'hover',
                    value: 'name',
                    label: 'name',
                    checkStrictly: true,
                    children: 'city_list',
                },
                status_list: [
                    {name: '不限', value: ''},
                    {name: '已完成', value: '2'},
                    {name: '未完成', value: '1'},
                ],
                ill_if_list: [
                    {name: '不限', value: ''},
                    {name: '是', value: '2'},
                    {name: '否', value: '1'},
                    {name: '未知', value: '3'},
                ],
                classification_list:[
                    {name: '不限', value: ''},
                    {name: '验真', value: 1},
                    {name: '自主注册', value: 2},
                    {name: 'DTP注册', value: 3},
                    {name: '医生端注册', value: 4},
                    {name: '试点随访', value: 5},
                    {name: '异地就诊', value: 6},
                ],
                T_list: [
                    {name: '不限', value: ''},
                    {name: 'T1', value: '1'},
                    {name: 'T2', value: '2'},
                    {name: 'T3', value: '3'},
                    {name: 'T4', value: '4'},
                ],
                Cycle_list: [
                    {name: '不限', value: ''},
                    {name: 'C1', value: 1},
                    {name: 'C2', value: 2},
                    {name: 'C3', value: 3},
                    {name: 'C4', value: 4},
                    {name: 'C5', value: 5},
                    {name: 'C6', value: 6},
                    {name: 'C7', value: 7},
                    {name: 'C8', value: 8},
                    {name: 'C9', value: 9},
                    {name: 'C10', value: 10},
                    {name: 'C11', value: 11},
                    {name: 'C12', value: 12},
                    {name: 'C13', value: 13},
                    {name: 'C14', value: 14},
                    {name: 'C15', value: 15},
                    {name: 'C16', value: 16},
                ],
                date_type_list: [
                    {name: '下次购药日期', value: '1'},
                    {name: '工单创建日期', value: '2'},
                    {name: '工单完成日期', value: '3'},
                    {name: '首次购药日期', value: '4'},
                ],
                invoice_info_list: [
                    {name: '不限', value: ''},
                    {name: '是', value: 1},
                    {name: '否', value: 2},
                ],

                treeOptions: {
                    checkStrictly: true,
                    emitPath: false,
                    expandTrigger: 'hover',
                    value: 'department_id',
                    label: 'name',
                    children: 'children'
                },
                province_list: [],
                hospital_list: [],

                tableData: [],
                columnData: [
                    {label: '患者名称', prop: 'patient_data.patient_name',formatter: showPatientName},
                    {label: '手机号', prop: 'patient_data.phone', formatter: showPhone},
                    {label: '工单来源', prop: 'task_data.source_str'},
                    {label: '使用药物', prop: 'task_data.drug_code_str'},
                    {label: '癌种', prop: 'patient_data.tumour'},
                    // {label: '癌种是否一致', prop: 'task_data.tumor_is_consistent_str'},
                    {label: '下次购药日期', prop: 'task_data.next_medication_date'},
                    {label: '下次访问日期', prop: 'task_data.next_visit_date'},
                    {label: '状态', prop: 'task_data.is_finish', formatter: showFinish},
                    {label: '跟进情况', prop: 'task_data.visit_result', formatter: showVisitResult},
                    {label: '随访时间', prop: 'task_data.finish_time'},
                ]
            }
        },
        computed:{
            ...mapState('comInformationData', {
                drug_code_list: 'drug_code_list',
                visit_task_medication_status: 'visit_task_medication_status',
                city_list: 'city_list',
                authority: 'authority'
            }),
            powerPatient() {
                //患者随访表
                return this.authority.includes('report-patient-all')
            },
            powerOperation() {
                //专员随访工单(运营)
                return this.authority.includes('report-operation-all')
            },
            powerFoundation() {
                //专员随访工单(基金会)
                return this.authority.includes('report-foundation-all')
            },
            powerPublic() {
                //附表-公益专员架构表
                return this.authority.includes('report-public-all')
            },
            powerResult() {
                //验真结果
                return this.authority.includes('report-verificationResult-all')
            },
            powerResultFoundation() {
                //验真结果（基金会）
                return this.authority.includes('report-resultFoundation-all')
            },
            powerPointFollowUp() {
                //试点随访（基金会）
                return this.authority.includes('report-pointFollowUp-all')
            },
        },
        filters: {
            showDateName(val) {
                let text = val == '1' ? '下次购药日期' :
                    val == '2' ? '工单创建日期' :
                        val == '3' ? '工单完成日期' :
                        val == '4' ? '首次购药日期' :
                            '';
                return text
            }
        },
        mounted() {
            this.getArea();
            this.getTableData()
            // this.getProvince();
            this.$eventBus.$on("pollPort",() =>{
                this.getArea();
                this.getTableData()
                // this.getProvince();
            })
            console.log(this.powerPatient,this.powerOperation,this.powerFoundation,this.powerPublic)
            this.$nextTick(() =>{
                this.tableHeight = this.$refs.common_table_view.clientHeight - this.$refs.header.clientHeight - this.$refs.bottom_page.clientHeight
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations('illuserData', {
                setVisitRow: 'setVisitRow'
            }),
            reportChange(){
                console.log(this.reportCheckList);
                if(this.reportCheckList.length < 1){
                    this.dialogVisible = false;
                    return;
                }
                let params = this.getSearchForm();
                params.export_type = this.reportCheckList.join();
                // console.log(params, '511');
                // return
                this.httpGet("/visit_task/export",params).then(res =>{
                    let {job_id} = res.data;
                    this.loadingExport = true;
                    this.dialogVisible = false;
                    this.exportPolling(job_id);
                })
            },
            exportPolling(job_id) {
                let i = 0;
                this.timer = setInterval(() => {
                    i++;
                    this.httpGet("/user/patients/check_export", {
                        job_id: job_id,
                    }).then((res) => {
                        if (res.data.finished) {
                            clearInterval(this.timer);
                            this.loadingExport = false;
                            let token = lcGetWithAge('token');
                            let url = `${res.data.url}?token=${token}`;
                            // console.log("0----finished", res.data.url, url);

                            let a = document.createElement('a');
                            document.body.appendChild(a);
                            a.href = url;
                            a.click();
                            // a.remove()
                            document.body.removeChild(a);
                        }
                    // }).catch(err =>{
                    //     // console.log(err)
                    //     clearInterval(this.timer);
                    //     this.$message.error(`导出失败,${err.msg}!`);
                    })
                }, 2000);
            },
            changeDateType(val) {
                this.searchForm.date_type = val;
                this.getTableData()
            },
            filtrate_dropdownCommand(val) {
                this.filtrate_dropdown = val;
                this.searchForm.province = [];
                this.searchForm.department_id = '';
                this.searchForm.hospital_id = '';
                this.getTableData();
            },
            getArea() {
                this.httpGet('/department').then(res => {
                    this.areaData = res.data;

                    const selectChildren = function (list) {
                        list.forEach(v => {
                            if (v.children && v.children.length > 0) {
                                selectChildren(v.children)
                            } else {
                                v.children = null
                            }
                        })
                    };
                    selectChildren(this.areaData)
                })
            },
            getHospital(hospital_name) {
                let params = {
                    // province: this.searchForm.province || '',
                    province: this.searchForm.province[0]?this.searchForm.province[0]:'',
                    city: this.searchForm.province[1]?this.searchForm.province[1]:'',
                    department_id: this.searchForm.department_id || '',
                    hospital_name: hospital_name || '',
                };
                if(!params.department_id && !params.province){
                    this.hospital_list = [];
                    this.searchForm.hospital_id = '';
                    return;
                }
                this.httpGet('/visit_task/hospital_list', params).then(res => {
                    this.hospital_list = res.data;
                })
            },
            provinceChange(){
                this.getHospital();
                this.getTableData()
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.getHospital(query);
                } else {
                    this.getHospital();
                }
            },
            changeCell(item, val) {
                if(val == 'Cycle_status'){
                    if(!item){
                        this.searchForm[val] = [''];
                    }else{
                        if(this.searchForm[val].includes('')){
                            let index = this.searchForm[val].findIndex(v => v == item)
                            this.searchForm[val].splice(index,1)
                        }
                        if(this.searchForm[val].includes(item)){
                            let index = this.searchForm[val].findIndex(v => v == item)
                            this.searchForm[val].splice(index,1)
                        }else{
                            this.searchForm[val].push(item)
                        }
                        if(this.searchForm[val].length <= 0){
                            this.searchForm[val] = [''];
                        }
                    }
                }else{
                    this.searchForm[val] = item;
                }
                if(val == 'hospital_id'){
                    this.getHospital();
                }
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getSearchForm() {
                let params = {
                    is_finish: this.searchForm.status,
                    name_or_phone: this.searchForm.input,
                    cycle_t: this.searchForm.T_status,
                    drug_code: this.searchForm.drug_code, //药物
                    source: this.searchForm.classification, //类别
                    cycle: this.searchForm.Cycle_status.join(), //周期
                    hospital_id: this.searchForm.hospital_id, //医院
                    department_id: this.searchForm.department_id, //部门
                    medication_status: this.searchForm.medication_status, //根据情况
                    // tumor_is_consistent: this.searchForm.tumor_is_consistent, //癌种是否一致
                    province: this.searchForm.province[0] ? this.searchForm.province[0] : '',
                    city: this.searchForm.province[1] ? this.searchForm.province[1] : '',

                    date_type: this.searchForm.date_type,

                    invoice_info: this.searchForm.invoice_info
                };
                let date = this.searchForm.date;
                if (date &&date.length > 0) {
                    params.start_time = date[0];
                    params.end_time = date[1];
                }
                return params
            },
            getTableData(v = 1) {
                let params = this.getSearchForm();
                params.page = v;
                params.page_size = this.pageSize;
                // console.log(params, '69');
                this.httpGet('/visit_task/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
            goToAudit(row) {
                let ids = [];
                this.tableData.forEach(v => {
                    ids.push(v.task_data.task_id)
                });
                let params = {
                    all: ids,
                    row_id: row.task_data.task_id,
                };
                this.setVisitRow(params);
                if(row.task_data.source_str === '异地就诊') {
                    this.$emit('changeTopTab', 'auditTwoView');
                    return;
                }
                this.$emit('changeTopTab', 'auditView');
            },
            getProvince() {
                this.httpGet('/stat_rep/province/list').then(res => {
                    this.province_list = res.data
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        .header {
            .search_item {
                align-items: center;
                .has_title {
                    min-width: 50px;
                    text-align: right;
                    white-space: nowrap;
                }
            }
        }
    }
</style>
<style lang="scss">
.el-cascader-menu{
    min-width: 200px;
    .el-cascader-menu__wrap{
        height: 300px;
    }
}
</style>